import { useMemo } from 'react';
import { AppliedFilters, type RawAppliedFilter } from 'app/domain';
import useSearchParametersAdapter from 'app/adapters/shared/searchParameters/useSearchParametersAdapter';
import useSearchProfileAdapter from 'app/adapters/shared/searchProfile/useSearchProfileAdapter';
import useSiteConfig from 'src/react/config/useSiteConfig';

// The unmerged applied-filter list: derives it from `searchParameters` /
// `searchProfile` via `AppliedFilters#raw`, with exclusions applied but no
// collection/duration merges and no display labels. Consumers that only need
// presence (`.length`) or the raw per-parameter breadcrumbs (tracking) use this
// rather than the merged, display-ready list `useAppliedFilters` builds.
const useRawAppliedFiltersAdapter = (): RawAppliedFilter[] => {
  const searchParameters = useSearchParametersAdapter();
  const searchProfile = useSearchProfileAdapter();
  const { appliedFilters: siteExclusions } = useSiteConfig();
  const appliedFilters = useMemo(
    () => new AppliedFilters(siteExclusions),
    [siteExclusions]
  );

  return appliedFilters.raw(searchParameters, searchProfile);
};

export default useRawAppliedFiltersAdapter;
